// Stepper.js
import React from "react";
import "./Stepper.scss";

const Stepper = ({ step }) => {
  return (
    <div className="stepper">
      <div className="stepper-text">
        <div className={`step ${step >= 1 ? "active" : ""}`}>1</div>
        <p className="stepper-text-p">Data diri</p>
      </div>

      <div className={`line-step ${step >= 1 ? "active" : ""}`}></div>
      <div className="stepper-text">
        <div className={`step ${step >= 2 ? "active" : ""}`}>2</div>
        <p className="stepper-text-p">Upload dokumen</p>
      </div>
      <div className={`line-step ${step >= 2 ? "active" : ""}`}></div>
      <div className="stepper-text">
        <div className={`step ${step >= 3 ? "active" : ""}`}>3</div>
        <p className="stepper-text-p">Perjanjian</p>
      </div>

      <div className={`line-step ${step >= 3 ? "active" : ""}`}></div>
      <div className="stepper-text">
        <div className={`step ${step >= 4 ? "active" : ""}`}>4</div>
        <p className="stepper-text-p">Selesai</p>
      </div>
    </div>
  );
};

export default Stepper;
